import PropTypes from 'prop-types';
import React from 'react';
import Button from '@ux/button';
import Close from '@ux/icon/x';

/**
 * Render the close button of the tooltip.
 *
 * @param {Object} props Component properties.
 * @returns {ReactElement} button
 * @private
 */
export default function TooltipClose({ close, className }) {
  return (
    <Button
      aria-hidden='true'
      type='button'
      className={ className }
      onClick={ close }
      design={ 'inline' }
      icon={ <Close /> }
    />
  );
}

/**
 * Property types definition.
 *
 * @enum {Object} propTypes
 * @private
 */
TooltipClose.propTypes = {
  close: PropTypes.func.isRequired,
  className: PropTypes.string
};
